"use client"

import React from "react"
import { createPortal } from "react-dom"
import { Toaster as Sonner } from "sonner"

const TOAST_OFFSET = {
  top: 80,
  right: 16,
  bottom: 16,
  left: 16,
}

export function Toaster(props) {
  const { style, ...restProps } = props || {}

  const toaster = (
    <Sonner
      {...restProps}
      theme="system"
      className="toaster group"
      containerAriaLabel="App notifications"
      closeButton
      toastOptions={{
        classNames: {
          toast: "app-sonner-toast",
        },
      }}
      style={{
        ...style,
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)",
        zIndex: 2147483647,
      }}
      richColors
      expand
      visibleToasts={5}
      position="top-right"
      offset={TOAST_OFFSET}
      mobileOffset={TOAST_OFFSET}
    />
  )

  if (typeof document === "undefined") {
    return toaster
  }

  return createPortal(toaster, document.body)
}
